export const REDUCER_NAME = "competitionResults";
export const SET_ERROR = `${REDUCER_NAME}/SET_ERROR`;
export const SET_COMPETITIONMATCHES = `${REDUCER_NAME}/SET_COMPETITIONMATCHES`;
export const APPEND_COMPETITIONMATCHES = `${REDUCER_NAME}/APPEND_COMPETITIONMATCHES`;
export const RESET_COMPETITIONMATCHES = `${REDUCER_NAME}/RESET_COMPETITIONMATCHES`;

export const getKey = (data) =>
  `${data.competitionId}_${data.type}_${data.season ?? "current"}`;
